"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var styles=require("@material-ui/core/styles");let e=styles.makeStyles(t=>({container:{"&:hover":{"& path":{fill:t.palette.common.gray600,stroke:t.palette.common.gray600}},height:16,width:16}}));exports.default=e;
//# sourceMappingURL=styles.js.map
